import { EntityType } from '@frontend/common';
import { IdentificationClient, MyIdentificationClient } from '@frontend/identification/api';
import { CreateIdentification, Identification, IdentificationType } from '@frontend/identification/types';
import { CommonMessage } from '@frontend/lang';
import { useAccountRepository } from '@frontend/repository';
import { FormattedMessage } from 'react-intl';

import UpdateModal from '../../../../modal/update-modal/update-modal.component';

export interface BasicAuthUpdateProps {
    entity_id: string;
    selfService?: boolean;
    onSubmitSuccess?: (value: Identification) => void;
}

export const BasicAuthCreate = (props: BasicAuthUpdateProps) => {
    const { currentAccount } = useAccountRepository();
    return (
        <UpdateModal<Identification, CreateIdentification>
            order={['key', 'secret']}
            values={{
                key: undefined,
                secret: null,
                type: IdentificationType.BASIC_AUTH,
                ...(!props.selfService && { entity_type: EntityType.USER, entity_id: props.entity_id })
            }}
            keyOverwrite={
                new Map([
                    ['key', CommonMessage.FORMS.EMAIL()],
                    ['secret', CommonMessage.FORMS.PASSWORD]
                ])
            }
            onSubmit={(value) =>
                props.selfService
                    ? MyIdentificationClient.postIdentification(currentAccount, value)
                    : IdentificationClient.postIdentification(currentAccount, value)
            }
            type={EntityType.IDENTIFICATION}
            label={
                <FormattedMessage
                    id='basic_auth.create.title'
                    defaultMessage='Create basic authentication'
                />
            }
            onSubmitSuccess={props.onSubmitSuccess}
            successMessageOverwrite={
                <FormattedMessage
                    id='basic_auth.create.success'
                    defaultMessage='Basic authentication created successfully'
                />
            }
        />
    );
};
